export default {
  scheduleId: {
    type: String,
    required: true
  },
  showDetailsModal1: {
    type: Boolean,
    default: false
  },
  showDetailsModal2: {
    type: Boolean,
    default: false
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/resources/props.js